import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppLightModal from '@/components/AppLightModal.vue'
import AppRadio from '@/components/AppRadio.vue'
import { DealerModel } from '@/interfaces/dealer'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { utcDateTimeToLocal, utcDateTimeToDate } from '@/utils/dateTime'
import { auditOptions, auditStatusText, auditCodes } from '@/helpers/audit'
import { auditDealer, deleteDealer, findDealer } from './gql'
import { AuditStatus } from '@/interfaces/status'
import { TypedGqlError } from '@/interfaces/error'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppRadio,
    AppLightModal
  }
})
export default class DealerDialog extends Vue {
  targetDealer: DealerModel | null = null

  utcDateTimeToLocal = utcDateTimeToLocal
  utcDateTimeToDate = utcDateTimeToDate
  auditOptions = auditOptions()
  auditCodes = auditCodes()
  auditStatusText = auditStatusText
  AuditStatus = AuditStatus
  denyReason = ''

  showAudit = false
  auditIndex = -1
  auditItems = [
    { text: '审核通过' },
    { text: '审核不通过' }
  ]

  auditDialog = {
    show: false,
    title: '',
    text: ''
  }

  denyDialog = {
    show: false,
    title: '审核不通过原因'
  }

  deleteDialog = {
    show: false,
    title: '删除经销商',
    text: ''
  }

  @Watch('auditDialog.show')
  onAuditDialogChanged (val: boolean) {
    if (!val) {
      this.auditIndex = -1
    }
  }

  editHandler (item: any, type: string) {
    this.targetDealer = item
    if (type === 'new') {
      this.$router.push({
        name: 'EditDealer',
        params: {
          type: type
        }
      })
    } else {
      this.$router.push({
        name: 'EditDealer',
        params: {
          type: type,
          id: item.id
        }
      })
    }
  }

  deleteHandler (item: any) {
    this.targetDealer = item
    this.deleteDialog.text = `是否确定删除经销商 “${item.realname}” ?`
    this.deleteDialog.show = true
  }

  // 审核
  auditHandler (item: DealerModel, choice: number) {
    let action = ''
    this.showAudit = false
    switch (choice) {
      case 0:
        action = '通过'
        break
      case 1:
        action = '不通过'
        break
      default:
        break
    }
    this.auditDialog.title = `审核${action}`
    this.auditDialog.text = `确定要${action} “${item.realname}” 的审核？`
    this.auditDialog.show = true
  }

  showAuditPop (item: DealerModel) {
    this.targetDealer = item
    this.showAudit = !this.showAudit
  }

  // delete request
  async deleteDealerById () {
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteDealer,
        variables: {
          dealerId: Number(this.targetDealer?.id)
        }
      })
      if (result) {
        showNotification({
          msg: '删除成功!',
          type: SnackType.Info
        })
      }
      this.deleteDialog.show = false
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // audit request
  async auditDealer (status: AuditStatus) {
    try {
      const result = await this.$apollo.mutate({
        mutation: auditDealer,
        variables: {
          dealerId: Number(this.targetDealer?.id),
          status,
          denyReason: this.denyReason
        }
      })
      if (result) {
        showNotification({
          msg: '操作成功!',
          type: SnackType.Info
        })
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async getDealerById (dealerId: number) {
    try {
      const result = await this.$apollo.query({
        query: findDealer,
        variables: {
          dealerId
        }
      })
      return result.data.findDealer
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
